const storageKey = 'uglyless-pro-license-key'

const validKeys = new Set([
  'demo-key',
  'uglyless-pro-test-2026',
  'uglyless-founder-100',
])

function normalizeKey(key: string): string {
  return key.trim().toLowerCase()
}

export function isValidKey(key: string): boolean {
  return validKeys.has(normalizeKey(key))
}

export function redeem(key: string): boolean {
  const normalizedKey = normalizeKey(key)

  if (!isValidKey(normalizedKey)) {
    return false
  }

  localStorage.setItem(storageKey, normalizedKey)
  return true
}

export function loadPersistedLicense(): boolean {
  const storedKey = localStorage.getItem(storageKey)

  return storedKey !== null && isValidKey(storedKey)
}

export function clearPersistedLicense(): void {
  localStorage.removeItem(storageKey)
}
